import React from 'react';

// Linhas de "esqueleto" exibidas no corpo da tabela enquanto os dados carregam
function TabelaCarregando({ colunas, linhas = 5, texto = 'Carregando dados...' }) {
    return (
        <>
            <tr className="tabela-carregando-topo">
                <td colSpan={colunas}>
                    <div className="tabela-carregando">
                        <span className="tabela-spinner" />
                        <span>{texto}</span>
                    </div>
                </td>
            </tr>
            {Array.from({ length: linhas }).map((_, i) => (
                <tr key={i} className="tabela-esqueleto">
                    {Array.from({ length: colunas }).map((__, j) => (
                        <td key={j}><span className="esqueleto-barra" style={{ width: `${55 + ((i + j) % 4) * 12}%` }} /></td>
                    ))}
                </tr>
            ))}
        </>
    );
}

export default TabelaCarregando;
